import {AlertesMisesAJourResolver} from "./pages/catalogue-examens/resultats/alertes-mises-a-jour.resolver";
import {ListDocumentsComponent} from "./pages/detail-examen/list-documents/list-documents.component";
import {NotificationNumberResolver} from "./notification.resolver";
import {IdRouteResolver} from "./pages/historique-modifications/filtres/id-route.resolver";
import {DetailExamenResolver} from "./pages/detail-examen/detail-examen.resolver";
import {ResultatsMisesAJourComponent} from "./pages/historique-modifications/resultats/resultats-misesajour.component";
import {FiltresMisesAJourComponent} from "./pages/historique-modifications/filtres/filtres-misesajour.component";
import {TypesReferentielResolver} from "./pages/historique-modifications/filtres/types.referentiel.resolver";
import {VosFiltresComponent} from "./pages/catalogue-examens/filtres/vos-filtres/vos-filtres.component";
import {CorrespondantTagsResolver} from "./correspondants-tags.resolver";
import {ResultatsCatalogueComponent} from "./pages/catalogue-examens/resultats/resultats-catalogue.component";
import {FiltresCatalogueComponent} from "./pages/catalogue-examens/filtres/filtres-catalogue.component";
import {CatalogueExamensComponent} from "./pages/catalogue-examens/catalogue-examens.component";

import {RouterModule, Routes} from "@angular/router";
import {CerbaCommonModule} from "@common/cerba-common.module";
import {NgModule} from "@angular/core";
import {MisesAJourResolver} from "./pages/historique-modifications/misesAjour.resolver";
import {HistoriqueModificationsComponent} from "./pages/historique-modifications/historique-modifications.component";
import {AccueilPageComponent} from "./pages/accueil/accueil.component";

import {EnsureUserAuthGuard, LogoutAuthGuard} from "@digicerba/common";
import {CerbaPageComponent} from "./cerba.component";
import {CatalogueTelechargerComponent} from "./pages/catalogue-dl/catalogue-dl.component";
import {DetailExamenPageComponent} from "./pages/detail-examen/detail-examen.component";
import {HeaderComponent} from "./header/header.component";
import {AccessResolver} from "./check.resolver";
import {ExamenResolver} from "./pages/catalogue-examens/examens.resolver";
import { ProfilValideResolver } from "./profil-valide.resolver";

const cerbaRoutes: Routes = [
  {
    path: 'cerba',
    component: CerbaPageComponent,
    canActivate: [EnsureUserAuthGuard],
    data:{ withoutInvite: true },
    resolve: {
      check: AccessResolver,
      nbAlerts: NotificationNumberResolver,
      profilValide: ProfilValideResolver,
    },
    children: [
      {path: 'accueil', component: AccueilPageComponent},
      {
        path: 'historique-modifications', component: HistoriqueModificationsComponent,
        resolve: {
          types: TypesReferentielResolver,
          misesajour: MisesAJourResolver
        }
      },
      {
        path: 'historique-modifications/:id', component: HistoriqueModificationsComponent,
        resolve: {
          types: TypesReferentielResolver,
          misesajour: MisesAJourResolver,
          id: IdRouteResolver
        }
      },
      {
        path: 'catalogue-examens', component: CatalogueExamensComponent,
        resolve: {
          filtres: ExamenResolver,
          tags: CorrespondantTagsResolver,
          nbAlerts: AlertesMisesAJourResolver
        }
      },
      { path: 'catalogue-telecharger', component: CatalogueTelechargerComponent },
      {
        path: 'detail-examen/:idLcsd', component: DetailExamenPageComponent,
        resolve: {
          detail: DetailExamenResolver
        }
      },
      {path: '', redirectTo: 'accueil', pathMatch: 'full'},
    ]
  },
  {path: 'logout', component: CerbaPageComponent, canActivate: [LogoutAuthGuard]},
  {path: '', redirectTo: 'cerba', pathMatch: 'full'}
];

@NgModule({
  declarations: [
    HeaderComponent,
    CerbaPageComponent,
    HistoriqueModificationsComponent,
    CatalogueTelechargerComponent,
    AccueilPageComponent,
    DetailExamenPageComponent,
    FiltresMisesAJourComponent,
    ResultatsMisesAJourComponent,
    CatalogueExamensComponent,
    FiltresCatalogueComponent,
    VosFiltresComponent,
    ResultatsCatalogueComponent,
    ListDocumentsComponent
  ],
  imports: [
    CerbaCommonModule,
    RouterModule.forRoot(cerbaRoutes, {useHash: true})
  ],
  exports: [
    RouterModule
  ],
  providers: [
    AccessResolver,
    TypesReferentielResolver,
    MisesAJourResolver,
    NotificationNumberResolver,
    CorrespondantTagsResolver,
    DetailExamenResolver,
    IdRouteResolver,
    AlertesMisesAJourResolver,
    ExamenResolver,
    ProfilValideResolver
  ]
})
export class CerbaRoutingModule { }



// WEBPACK FOOTER //
// /home/vsts/work/1/s/digicerba-modules/digicerba-catalogue-examen/digicerba-catalogue-examen-web/src/angular/cerba/src/app/pages/cerba/cerba.router.ts